document.addEventListener("DOMContentLoaded", async () => {
  // SWIPERS START
  const ddBottomSwiper = new Swiper(".dd-swiperBottom", {
    loop: false,
    spaceBetween: 10,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    on: {
      init: function () {
        previousActiveIndex = this.activeIndex;
      },
      click: function () {
        // console.log("this.activeIndex",this.activeIndex)
        // console.log("this.clickedIndex",this.clickedIndex)
        // console.log("previousActiveIndex",previousActiveIndex)

        if (this.clickedIndex < previousActiveIndex) {
          // console.log("Left");
          this.slideTo(this.clickedIndex - 1, 300, true);
          // console.log(this.clickedIndex - 1);
        } else {
          this.slideTo(this.clickedIndex, 300, true);
        }
        previousActiveIndex = this.clickedIndex;
        // console.log("-----------",)
      },
    },
  });

  const ddTopSwiper = new Swiper(".dd-swiperTop", {
    loop: true,
    spaceBetween: 10,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: ddBottomSwiper,
    },
  });

  const parallaxSwiper = new Swiper(
    ".camping-outside-fluid-swiper-container .swiper",
    {
      speed: 600,
      parallax: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    }
  );

  const productSwiper = new Swiper(
    ".camping-out-vehicle-slider-container .swiper",
    {
      pagination: {
        el: ".swiper-pagination.vehicle-swiper",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    }
  );
  // SWIPERS END

  // DD START
  const ddContent = document.querySelector(".camping-outdoor-dropdown-content");
  const noVehicleFoundText = ddContent.dataset.noVehicleFound;
  const ddList = document.querySelector(".camping-outdoor-dd-list");
  const ddSelections = document.querySelector(
    ".camping-outdoor-selection-container"
  );
  const ddButton = document.querySelector(".dropdown-button");
  const makeModels = getMakeModels();
  const makes = Object.keys(makeModels);
  const resetDDButton = document.querySelector("#resetDD");
  const campingOutdoorBannerContainer = document.querySelector(
    ".camping-outdoor-banner-container"
  );
  const vehicleSliderContainer = document.querySelector(
    ".camping-out-vehicle-slider-container"
  );
  const variantsDDContainer = document.querySelector(
    ".pp-wrapper[data-role='camping-outdoor-variant-dropdown']"
  );

  const vehicleSliderButtons = document.querySelectorAll(
    "button[data-role='display-product-info']"
  );

  vehicleSliderButtons.forEach((button) => {
    button.addEventListener("click", () => {
      displayProductInfo(button.dataset.makeModel);
      const dropdownElement = document.querySelector(".mainSelection");
      dropdownElement.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  });

  getInitialDropdown({ addSearchBar: true });

  ddButton.addEventListener("click", handleDropdownButtonClick);

  // FUNCTIONS START

  function handleKeydown(e) {
    const highlightedElement = ddContent.querySelector(
      ".camping-outdoor-dd-list-item.highlight"
    );
    const focusableElements = ddContent.querySelectorAll(
      ".camping-outdoor-dd-list-item:not(.camping-outdoor-dd-search-bar-li):not(.camping-outdoor-dd-list-splitter):not(.no-hover)"
    );
    switch (e.key) {
      case "Escape":
        closeDropdown();
        highlightedElement?.classList.remove("highlight");
        break;
      case "ArrowDown": {
        e.preventDefault();
        ddContent.dataset.keyboardControls = "true";
        const nextElement = highlightedElement?.nextElementSibling;
        if (!nextElement) {
          const elementToFocus = focusableElements[0];
          elementToFocus.classList.add("highlight");
          centerElementInContainer(elementToFocus, ddList);
        } else {
          highlightedElement.classList.remove("highlight");
          nextElement.classList.add("highlight");
          centerElementInContainer(nextElement, ddList);
        }
        break;
      }
      case "ArrowUp": {
        e.preventDefault();
        ddContent.dataset.keyboardControls = "true";
        const previousElement = highlightedElement?.previousElementSibling;
        if (!previousElement) {
          const elementToFocus =
            focusableElements[focusableElements.length - 1];
          elementToFocus.classList.add("highlight");
          centerElementInContainer(elementToFocus, ddList);
        } else {
          highlightedElement.classList.remove("highlight");
          previousElement.classList.add("highlight");
          centerElementInContainer(previousElement, ddList);
        }
        break;
      }
      case "Enter":
        e.preventDefault();
        highlightedElement.click();
        break;
    }
  }

  function centerElementInContainer(element, container) {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    const offset =
      elementRect.top -
      containerRect.top -
      containerRect.height / 2 +
      elementRect.height / 2;
    container.scrollTop += offset;
  }
  function getInitialDropdown({ addSearchBar }) {
    if (addSearchBar) {
      appendSearchBar();
    }
    ddList.style.height = "";
    fillListMakes(makes);
  }

  function handleDropdownButtonClick() {
    const isOpened = ddContent.dataset.dropdownOpened === "true";
    if (isOpened) {
      closeDropdown();
    } else {
      openDropdown();
    }
  }

  function openDropdown() {
    ddContent.dataset.dropdownOpened = true;
    ddContent.querySelector(".camping-outdoor-search-bar")?.focus();
    window.addEventListener("keydown", handleKeydown);
    window.addEventListener("click", handleDocumentClick);
  }

  function closeDropdown() {
    ddContent.dataset.dropdownOpened = false;
    ddContent.dataset.keyboardControls = "false";
    window.removeEventListener("keydown", handleKeydown);
    window.removeEventListener("click", handleDocumentClick);
  }

  function handleDocumentClick(e) {
    const closestDropdownContent = e.target.closest(
      ".camping-outdoor-dropdown-content"
    );
    if (
      !closestDropdownContent &&
      !e.target.classList.contains("camping-outdoor-dd-list-item")
    ) {
      closeDropdown();
    }
  }

  function fillListMakes(items) {
    items.forEach((item) => {
      const liElement = getMakeListItem({ make: item });
      ddList.append(liElement);
    });
  }

  function fillListModels(make) {
    const models = makeModels[make];
    clearDD();
    models.forEach((model) => {
      const liElement = getModelListItem({ model, link: `${make} ${model}` });
      ddList.append(liElement);
    });
  }

  function clearDD() {
    const totalChildren = ddList.children.length;
    for (let i = totalChildren - 1; i > 0; i--) {
      ddList.removeChild(ddList.children[i]);
    }
  }

  function appendSearchBar() {
    const li = document.createElement("li");
    li.classList.add(
      "camping-outdoor-dd-list-item",
      "camping-outdoor-dd-search-bar-li"
    );
    const input = document.createElement("input");
    input.type = "text";
    input.classList.add("camping-outdoor-search-bar");
    input.addEventListener("input", handleSearchBarChange);
    input.placeholder = "Search";
    li.append(input);
    ddList.append(li);
  }

  function handleSearchBarChange(e) {
    const searchValue = e.target.value.toLowerCase();
    ddList.style.height = "";

    clearDD();
    if (searchValue === "") {
      getInitialDropdown({ addSearchBar: false });
      return;
    }
    const foundArray = [];
    Object.keys(makeModels).forEach((make) => {
      const models = makeModels[make];

      if (make.toLowerCase().includes(searchValue)) {
        foundArray.push({ type: "make", name: make });
      }

      models.forEach((model) => {
        if (model.toLowerCase().includes(searchValue)) {
          foundArray.push({ type: "model", name: `${make} ${model}` });
        }
      });
    });

    if (foundArray.length < 5) {
      const newHeight = 68 + foundArray.length * 52 + "px";
      ddList.style.height = newHeight;
    }

    if (foundArray.length < 1) {
      const listItem = getListItem({ text: noVehicleFoundText });
      ddList.append(listItem);
      ddList.style.height = "120px";
      return;
    }

    foundArray.sort((a, b) => {
      if (a.type === "make" && b.type === "model") return -1;
      if (a.type === "model" && b.type === "make") return 1;
      return 0;
    });
    foundArray.forEach((item) => {
      if (item.type === "make") {
        const makeLi = getMakeListItem({ make: item.name });
        ddList.append(makeLi);
      } else {
        const modelLi = getModelListItem({ model: item.name, link: item.name });
        ddList.append(modelLi);
      }
    });
  }

  function getSplitter({ text }) {
    const li = document.createElement("li");
    li.classList.add(
      "camping-outdoor-dd-list-item",
      "camping-outdoor-dd-list-splitter"
    );
    li.innerText = text;
    return li;
  }

  function getMakeListItem({ make }) {
    const li = document.createElement("li");
    li.classList.add("camping-outdoor-dd-list-item");
    li.innerText = make;
    li.addEventListener("click", () => {
      removeSelectionItems();
      if (makeModels[make].length < 5) {
        const newHeight = 68 + makeModels[make].length * 52 + "px";
        ddList.style.height = newHeight;
      } else {
        ddList.style.height = "";
      }
      createSelectionItem({ text: make });
      fillListModels(make);
      document.querySelector(".camping-outdoor-search-bar").value = "";
    });
    addHighlightEventListeners(li);
    return li;
  }
  function getModelListItem({ model, link }) {
    const li = document.createElement("li");
    li.classList.add("camping-outdoor-dd-list-item");
    li.innerText = model;
    li.addEventListener("click", () => {
      displayProductInfo(model);
    });
    addHighlightEventListeners(li);
    return li;
  }

  async function displayProductInfo(makeModel) {
    const variantDDButton = document.querySelector(".select-btn");
    vehicleSliderContainer.style.display = "none";
    campingOutdoorBannerContainer.style.display = "none";
    const foundVehicle = window.campingOutsideVehicles.find(
      (item) => `${item.make} ${item.model}` === makeModel
    );
    if (!foundVehicle) {
      console.error("could not find the vehicle");
      return;
    }
    const optionsList = document.querySelector("#selectContentUI ul.options");
    const makesElements = [...optionsList.children];
    const makeLiElement = makesElements.find(
      (item) => item.textContent === foundVehicle.make
    );
    makeLiElement.click();
    const modelElements = [...optionsList.children];
    // console.log(modelElements.map((item) => item.textContent));
    const modelLiElement = modelElements.find(
      (item) => item.textContent === makeModel
    );
    modelLiElement.click();
    setTimeout(() => {
      variantDDButton.click();
    }, 100);
    variantsDDContainer.style.display = "block";
  }

  resetDDButton.addEventListener("click", () => {
    resetCampingOutdoorPage();
  });
  function resetCampingOutdoorPage() {
    const selectionDeleteButton = document.querySelector(
      ".camping-outdoor-selection-delete"
    );
    selectionDeleteButton?.click();
    campingOutdoorBannerContainer.style.display = "block";
    vehicleSliderContainer.style.display = "block";
    variantsDDContainer.style.display = "none";
  }

  function addHighlightEventListeners(el) {
    el.addEventListener("mouseenter", () => {
      const isKeyboardMode = ddContent.dataset.keyboardControls === "true";
      if (!isKeyboardMode) {
        el.classList.add("highlight");
      }
    });
    el.addEventListener("mouseleave", () => {
      const isKeyboardMode = ddContent.dataset.keyboardControls === "true";
      if (!isKeyboardMode) {
        el.classList.remove("highlight");
      }
    });
  }

  function getListItem({ text }) {
    const li = document.createElement("li");
    li.classList.add("camping-outdoor-dd-list-item", "no-hover");
    li.innerText = text;
    return li;
  }

  function redirectToProductPage(makeModel) {
    const changedMakeModel = makeModel.toLowerCase().replaceAll(" ", "-");
    window.location = `${window.Shopify.routes.root}products/${changedMakeModel}`;
  }

  function removeSelectionItems() {
    ddSelections.innerHTML = "";
  }
  function createSelectionItem({ text }) {
    const div = document.createElement("div");
    const cross = document.createElement("button");
    cross.classList.add("camping-outdoor-selection-delete");
    cross.addEventListener("click", () => {
      clearDD();
      getInitialDropdown({ addSearchBar: false });
      div.classList.remove("visible");
      setTimeout(() => {
        div.remove();
      }, 200);
    });
    const textEl = document.createElement("p");
    div.classList.add("camping-outdoor-selection-item");
    textEl.innerText = text;
    div.append(textEl, cross);
    ddSelections.append(div);
    setTimeout(() => {
      div.classList.add("visible");
    }, 20);
  }

  function getMakeModels() {
    const data = {};

    window.campingOutsideVehicles.forEach((vehicle) => {
      if (data[vehicle.make]) {
        data[vehicle.make].push(`${vehicle.make} ${vehicle.model}`);
      } else {
        data[vehicle.make] = [`${vehicle.make} ${vehicle.model}`];
      }
    });
    const sortedData = {};

    Object.keys(data)
      .sort()
      .forEach((make) => {
        sortedData[make] = data[make].sort();
      });
    return sortedData;
  }
  // DD END
});
